var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconViewList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8C7.34315 8 6 9.34315 6 11C6 12.6569 7.34315 14 9 14C10.6569 14 12 12.6569 12 11C12 9.34315 10.6569 8 9 8Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9C14.8954 9 14 9.89543 14 11C14 12.1046 14.8954 13 16 13H32C33.1046 13 34 12.1046 34 11C34 9.89543 33.1046 9 32 9H16Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20C6 18.3431 7.34315 17 9 17C10.6569 17 12 18.3431 12 20C12 21.6569 10.6569 23 9 23C7.34315 23 6 21.6569 6 20Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18C14.8954 18 14 18.8954 14 20C14 21.1046 14.8954 22 16 22H32C33.1046 22 34 21.1046 34 20C34 18.8954 33.1046 18 32 18H16Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 29C6 27.3431 7.34315 26 9 26C10.6569 26 12 27.3431 12 29C12 30.6569 10.6569 32 9 32C7.34315 32 6 30.6569 6 29Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 27C14.8954 27 14 27.8954 14 29C14 30.1046 14.8954 31 16 31H32C33.1046 31 34 30.1046 34 29C34 27.8954 33.1046 27 32 27H16Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewList);
export default __webpack_public_path__ + "static/media/iconViewList.51ac55ff.svg";
export { ForwardRef as ReactComponent };